import styled from 'styled-components'

export const Root = styled.div`
  margin: ${props => props.margin};
  padding: ${props => props.padding};
`

export const Separator = styled.span`
  &[data-separator='true'] {
    color: ${props => props.theme.palette.gray[50]};
    font-family: ${props => props.theme.typography.fontFamily};
    font-size: 16px;
    letter-spacing: 0;

    &::before {
      content: '/';
      padding: 0 5px;
    }

    &:last-of-type,
    &:last-of-type::before {
      content: '';
      display: none;
    }
  }
`
